// Rails
import Rails from './rails/rails-ujs'

import '@hotwired/turbo-rails'

// App
import './controllers/public'
import Polyfills from './lib/polyfills'
import ImageLazyLoading from './lib/image_lazy_loading'
import MinimalAnalytics from './lib/minimal_analytics'

// Start everything that needs to be started
Rails.start()
Polyfills.start()
ImageLazyLoading.start()
MinimalAnalytics.start()
